import { TableCell, TableSortLabel, Box } from "@mui/material";
import { visuallyHidden } from "@mui/utils";

export interface HeadCell<T> {
  id: keyof T;
  label: string;
  disablePadding?: boolean;
  alignRight?: boolean;
}

export type TableSortOrder = "asc" | "desc";

function descendingComparator<T>(a: T, b: T, orderBy: keyof T) {
  const aValue = a[orderBy];
  const bValue = b[orderBy];

  // Only sort if both values are string or number
  if ((typeof aValue === "string" || typeof aValue === "number") && (typeof bValue === "string" || typeof bValue === "number")) {
    if (bValue < aValue) {
      return -1;
    }
    if (bValue > aValue) {
      return 1;
    }
    return 0;
  }

  // If not comparable, do not sort (return 0)
  return 0;
}

/*export function getComparator<Key extends keyof any>(
  order: TableSortOrder,
  orderBy: Key
): (a: { [key in Key]: unknown }, b: { [key in Key]: unknown }) => number {
  return order === "desc" ? (a, b) => descendingComparator(a, b, orderBy) : (a, b) => -descendingComparator(a, b, orderBy);
}*/
export function getComparator<T, Key extends keyof T>(order: TableSortOrder, orderBy: Key): (a: T, b: T) => number {
  return order === "desc" ? (a, b) => descendingComparator(a, b, orderBy) : (a, b) => -descendingComparator(a, b, orderBy);
}

export interface SortableTableHeadProps<T> {
  className?: string;
  headCell: HeadCell<T>;
  onRequestSort: (event: React.MouseEvent<unknown>, property: keyof T) => void;
  order: TableSortOrder;
  orderBy: string;
}

export interface SimpleSortableTableHeadProps<T> {
  id: keyof T;
  label: string;
  className?: string;
}

export function SortableTableHead<T>(props: SortableTableHeadProps<T>) {
  const { order, orderBy, onRequestSort } = props;
  const createSortHandler = (property: keyof T) => (event: React.MouseEvent<unknown>) => {
    onRequestSort(event, property);
  };

  return (
    <TableCell
      className={props.className}
      key={String(props.headCell.id)}
      align={props.headCell.alignRight ? "right" : "left"}
      padding={props.headCell.disablePadding ? "none" : "normal"}
      sortDirection={orderBy === props.headCell.id ? order : false}>
      <TableSortLabel
        active={orderBy === props.headCell.id}
        direction={orderBy === props.headCell.id ? order : "asc"}
        onClick={createSortHandler(props.headCell.id)}>
        {props.headCell.label}
        {orderBy === props.headCell.id ? (
          <Box component="span" sx={visuallyHidden}>
            {order === "desc" ? "sorted descending" : "sorted ascending"}
          </Box>
        ) : null}
      </TableSortLabel>
    </TableCell>
  );
}
